import { TYPES, elementMap } from "../../../ProseMirrorNode.constants";

/**
 * Translates the ProseMirror node types into the types expected by the Read page plugin.
 *
 * @param {object} node
 * @returns {string} identifier type
 */
const getIdentifierType = (node) => {
  if (node.type === TYPES.heading) {
    const level = node.attrs.level;
    if ([1, 2].includes(level)) {
      return "h2";
    }

    if ([3, 4, 5, 6].includes(level)) {
      return "h3";
    }
  }

  if (elementMap[node.type]) return elementMap[node.type];

  return null;
};

export default getIdentifierType;
